import { Component } from '@angular/core';
import { IzzyChannelExtensionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Channel Extensions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzychannelextension-form',
    templateUrl: './izzychannelextension.form.component.html'
})
export class IzzyChannelExtensionFormComponent extends BaseFormComponent {
    public record!: IzzyChannelExtensionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'extensionDetails', sectionName: 'Extension Details', isExpanded: true },
            { sectionKey: 'configurationAndCredentials', sectionName: 'Configuration and Credentials', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

